var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Page Not Found")]),_c('h3',[_vm._v("Requested URL: "+_vm._s(_vm.url))]),_c('h3',[_vm._v("Please, go back to "),_c('v-btn',{attrs:{"to":"/"}},[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }